import React from 'react';

const Info = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4479_7062)'>
        <path
          d='M7.33301 4.66732H8.66634V6.00065H7.33301V4.66732ZM7.33301 7.33398H8.66634V11.334H7.33301V7.33398ZM7.99967 1.33398C4.31967 1.33398 1.33301 4.32065 1.33301 8.00065C1.33301 11.6807 4.31967 14.6673 7.99967 14.6673C11.6797 14.6673 14.6663 11.6807 14.6663 8.00065C14.6663 4.32065 11.6797 1.33398 7.99967 1.33398ZM7.99967 13.334C5.05967 13.334 2.66634 10.9407 2.66634 8.00065C2.66634 5.06065 5.05967 2.66732 7.99967 2.66732C10.9397 2.66732 13.333 5.06065 13.333 8.00065C13.333 10.9407 10.9397 13.334 7.99967 13.334Z'
          fill='#161410'
        />
      </g>
      <defs>
        <clipPath id='clip0_4479_7062'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Info;
